<mat-card class="ticket-card" appearance="outlined">
  <mat-card-content>
    <div class="ticket-header">
      <div class="ticket-detail">
        <div class="ticket-subject">{{ ticketInfo.subject }}</div>
        <div class="ticket-status">
          <glxy-badge [color]="badgeColor">{{ ticketInfo.status }}</glxy-badge>
        </div>
      </div>
      <span class="ticket-date">{{ ticketInfo.createdAt }}</span>
      <span class="ticket-channel">{{ ticketInfo.groupName }}</span>
      <span class="ticket-channel">{{ ticketInfo.channel }}</span>
    </div>
    @if (isMinView) {
      <span class="ticket-body">{{ ticketInfo.description | trimDescription : 80 }}</span>
    }
    @if (!isMinView) {
      <span class="ticket-body">{{ ticketInfo.description }}&nbsp;</span>
    }
    @if (ticketInfo.description.length > 80 && isMinView) {
      <a (click)="showMoreLess()">
        {{ 'INBOX.TICKETS.VIEW_MORE' | translate }}
      </a>
    }
    @if (ticketInfo.description.length > 80 && !isMinView) {
      <a (click)="showMoreLess()">
        {{ 'INBOX.TICKETS.VIEW_LESS' | translate }}
      </a>
    }
  </mat-card-content>
  <mat-card-actions align="end">
    <div class="card-actions__secondary">
      <span class="ticket-footer">{{ ticketInfo.requester }}</span>
    </div>
    <div class="card-actions__primary">
      <a mat-button class="view-link-button" color="primary" href="{{ ticketInfo.url }}" target="_blank">
        <span>{{ 'INBOX.TICKETS.VIEW' | translate }}</span>
        <mat-icon class="link-icon">launch</mat-icon>
      </a>
    </div>
  </mat-card-actions>
</mat-card>
